import { Component, OnInit, Compiler, ViewChild, Input, ElementRef } from '@angular/core';
import { first, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorComponent } from '../confirm/error.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material/dialog';
import { FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from '../util';
import { CommonService } from '../service/commons-service';
import { Common } from '../util/common';

@Component({ templateUrl: './functionalSkillMaster.component.html', styleUrls: ['./functionalSkillMaster.component.css'] })
export class FunctionalSkillMasterComponent implements OnInit {

  @ViewChild('closeModel', {read: ElementRef}) closeModel: ElementRef;
   users: any = {};
   formObj: any;
   config: any;
   formInfoList: any[] = [];
   submitted = false;
   loginImageURL: any = "";
   loginUserName: any = "";
   baseURL: any = null;
   showHideModel: boolean = true;
   loading: boolean = false;
   activeUserCount: number = 0;
   inactiveUserCount: number = 0;
   towerId: any;
   towerName: any;
   superUserType: any = "";
   allTowers: any = [];
   allTraining: any = [];
   allIbus: any = [];
   positionName: any;
   allPositions: any = [];
   selectedTowerId: any = 0;
   selectedPositionId: any = 0; //10
   towerSelect: any = "1";
   currIndex:number;


  constructor(private modalService: MatDialog,
    private router: Router,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private appConfig: AppConfig,
    config: NgbDatepickerConfig,
    public common: Common,
    private _compiler: Compiler) {
    this._compiler.clearCache();
    this.users = JSON.parse(localStorage.getItem('user'));
    if (!this.users || !this.users.userData) {
      this.commonService.logout
      return;
    }
    if (this.users && this.users.userData) {
      this.loginImageURL = '/assets/default.png';
      this.loginUserName = this.users.userData.userFullName;
      this.towerId = this.users.userData.towerId;
      this.towerName = localStorage.getItem('towerName');
      // All process done with tower selected on dashboard
      this.selectedTowerId = (this.towerId != null || this.towerId != undefined) ? this.towerId : 0;
    }
    if (localStorage.getItem('superUserType')) {
      this.superUserType = localStorage.getItem('superUserType');
    }
    let currentDate = new Date();
    this.config = config;
    this.config.minDate = { year: currentDate.getFullYear() - 10, month: currentDate.getMonth(), day: currentDate.getDate() };
    this.config.maxDate = { year: 2099, month: 12, day: 31 };
    this.config.markDisabled = false;
    this.initUserInfo();
  }

  //initailised user form
  ngOnInit() {
    this.formObj = this.formBuilder.group({
      skillName: ['', Validators.required],
      skillId: new FormControl(null),
      towerId: new FormControl(this.selectedTowerId),
      skillCode: ['Dummy', Validators.required],
      targetScore: ['', Validators.required],
      positionId: ['', Validators.required],
      arrOfTraining : this.formBuilder.array([this.formBuilder.group({trainingPoint:''})])
    });
    this.initialization();
  }

  get arr_of_training() {
    return this.formObj.get('arrOfTraining') as FormArray;
  }

  addTraining() {
    this.arr_of_training.push(this.formBuilder.group({trainingPoint:''})); 
  }

  deleteTraining(i) {
    this.arr_of_training.removeAt(-1); 
  }

  get arr_of_training_update() {
    return this.formObj.get('arrOfTraining') as FormArray;
  }

  addTrainingUpdate(obj?) {
    if(obj){
      this.arr_of_training_update.push(this.formBuilder.group({trainingPoint:obj.trainingPoint})); 
    }else{
      this.arr_of_training_update.push(this.formBuilder.group({trainingPoint:''})); 
    } 
  }

  deleteTrainingUpdate(i) {
    this.arr_of_training_update.removeAt(-1);   
  }

 

  //initial setup level assets
  private initialization() {
    this.getAllSkills();
    this.getTowerList();
    this.getPositionList(this.selectedTowerId);    
  }
  /**
  * Update position list if cange tower in add comp. form
  */
  updatePositionList() {
    this.getPositionList(this.selectedTowerId);
  }
  //reset user form
   initUserInfo() {
    this.formObj = this.formBuilder.group({
      skillName: ['', Validators.required],
      skillId: new FormControl(null),
      towerId: new FormControl(this.selectedTowerId),
      skillCode: ['Dummy', Validators.required],
      targetScore: ['', Validators.required],
      positionId: ['', Validators.required],
      arrOfTraining: new FormArray([])
  
    });
  }

  //reset user form 
  private setUpdateUserInfo(formInfo, i) {
    this.initUserInfo();
    this.allTraining = JSON.parse(this.formInfoList[i].arrOfTraining);

    this.formObj = this.formBuilder.group({
      skillName: new FormControl(formInfo.skillName),
      skillId: new FormControl(formInfo.skillId),
      towerId: new FormControl(formInfo.towerId),
      skillCode: new FormControl(formInfo.skillCode),
      targetScore: new FormControl(formInfo.targetScore),
      positionId: new FormControl(formInfo.positionId),
      arrOfTraining: new FormArray([])
    });

    for(const obj of this.allTraining) {
      this.addTrainingUpdate(obj);
    }
  }

  // Get All user list
  private getAllSkills() {
    this.formInfoList = [];
    if(this.selectedTowerId > 0 && this.selectedPositionId > 0) {
      this.loading = true;
      this.commonService.postAllFunSkills(this.selectedTowerId, this.selectedPositionId).pipe(first()).subscribe(      data => {
        this.formInfoList = data;
        this.loading = false;
        if(data.length === 0) {
          localStorage.setItem('errorMsg', "No results! Please change the filter to see the results.");
          this.showerror();
        }
      },
      error => {
        this.loading = false;
        localStorage.setItem('errorMsg', error.statusText);
        this.showerror();
      }
    )
    }
  }

  

  // Save new user profile
  private onSubmit(formInfo) {
    if (this.formObj.invalid) {
      this.submitted = true;
      return;
    } else {
      // check ibu name is already exits
      if (this.checkSkillName(formInfo.skillName)) {
        localStorage.setItem('errorMsg', formInfo.skillName + ' competency already exits!');
        this.showerror();
        return;
      }
      this.loading = true;
      if (!this.common.isSuperUser()) {
        delete formInfo.towerId;
        formInfo.towerId = 0;
        formInfo.towerId = this.selectedTowerId;
      }
      formInfo.arrOfTraining.forEach((element, index) => {
        formInfo.arrOfTraining[index]['id'] = index+1;
      });
      this.commonService.saveFunSkill(formInfo).pipe(first()).subscribe(
        data => {
          this.loading = false;
          this.formObj.reset();
          localStorage.setItem('errorMsg', 'Competency Added successfully!');
          this.initialization();
          this.closeModels();
          this.showerror();
        },
        error => {
          this.loading = false;
          localStorage.setItem('errorMsg', 'Must enter all the fields!');
          this.showerror();
        }
      )
    }
  }

  // update user profile 
  private updateSkill(formInfo) {
    if (this.formObj.invalid) {
      localStorage.setItem('errorMsg', 'Please enter user information!');
      this.showerror(); 
      return
    }
    if (formInfo != null) {
      if (formInfo) {
        this.loading = true;
        formInfo.arrOfTraining.forEach((element, index) => {
          formInfo.arrOfTraining[index]['id'] = index+1;
        });
        this.commonService.updateFunSkill(formInfo).pipe(first()).subscribe(
          data => {
            this.loading = false;
            this.initialization();
            this.closeModels();
            localStorage.setItem('errorMsg', 'Competency is updated successfully!');
            this.showerror();
          },
          error => {
            this.loading = false;
            localStorage.setItem('errorMsg', error.statusText);
            this.showerror();
          }
        )
      }
    }
  }

  // Delete user profile
  private onDeleteSubmit(userInfo) {
    this.loading = true;
    //set login user email
    this.commonService.userDeletion(userInfo).pipe(first()).subscribe(
      data => {
        this.loading = true;
        this.initialization();
        localStorage.setItem('errorMsg', 'Record is deleted successfully!');
        localStorage.removeItem('errorMsg');
        this.showerror();
      },
      error => {
        this.loading = false;
        localStorage.setItem('errorMsg', error.statusText);
        this.showerror();
      }
    )
  }

  // check if name is already exits
  private checkSkillName(skillName) {
    let isSkillNameExits = false;
    for (let i = 0; i < this.formInfoList.length; i++) {
      if (skillName.toLowerCase() == this.formInfoList[i].skillName.toLowerCase()) {
        isSkillNameExits = true;
        break;
      }
    }
    return isSkillNameExits;
  }

  //show dailog box for user messages
  showerror() {
    const modal = this.modalService.open(ErrorComponent, {
      width: 'auto',
      data: { title: 'Confirm title', message: 'Confirm message' }
    });
  }

  //close dailog box
  private closeModels() {
    this.closeModel.nativeElement.click();
  }


  private getTowerList() {
    this.loading = true;
    this.commonService.getTowerList().pipe(first()).subscribe(
      data => {
        this.loading = false;
        this.allTowers = data;
      },
      error => {
        this.loading = false;
        localStorage.setItem('errorMsg', error.statusText);
        this.showerror();
      }
    )
  }

   getPositionList(towerId) {
     
    if(towerId > 0) {
      this.loading = true; 
      this.commonService.getPositionList(towerId).pipe(first()).subscribe(
        data => {
          this.loading = false;
          this.allPositions = data;
        },
        error => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.showerror();
        }
      )
    } else {
      this.formInfoList = [];
      this.allPositions = [];
      this.selectedPositionId = 0;
    }
    
  }

}
